/**
 * usePlan — convenience hook for checking plan limits defined in config.
 */

import { usePurchases } from '../contexts/PurchasesContext';
import { PLANBASE_CONFIG } from '../config';
import type { PlanTier } from '../lib/revenuecat';
import { useAuth } from '../contexts/AuthContext';
import { hasAdminAccess } from '../lib/admin';

export function usePlan() {
  const { plan, planLoading, offering, purchase, restore, refreshPlan, iapAvailable } = usePurchases();
  const { user } = useAuth();

  const isAdmin = hasAdminAccess(user?.id, user?.email);
  const tier: PlanTier = isAdmin ? 'enterprise' : plan.tier;
  const limits = PLANBASE_CONFIG.planLimits[tier] ?? PLANBASE_CONFIG.planLimits.free;

  return {
    // State
    tier,
    plan,
    planLoading,
    iapAvailable,

    // Limits (resolved from config)
    maxProjects:         limits.maxProjects,
    maxImagesPerProject: limits.maxImagesPerProject,
    canViewUnlimited:    limits.canViewDiscovery === -1,
    discoveryLimit:      limits.canViewDiscovery,

    // Checks
    isPro:        tier === 'pro' || tier === 'enterprise',
    isEnterprise: tier === 'enterprise',
    isFree:       tier === 'free',
    isAdmin,

    canUpload:    tier !== 'free' || limits.maxProjects > 0,
    canAddMore:   (current: number) => limits.maxProjects === -1 || current < limits.maxProjects,

    // Actions
    offering,
    purchase,
    restore,
    refreshPlan,
  };
}
